import { connect } from 'react-redux';
import { Editor } from '../presentation/Editor';

const mapStateToProps = (state, ownProps) => {
  const { variantUrlsafe } = ownProps.computedMatch.params;
  return ({
    variantUrlsafe,
    page: state.page,
    variant: Object.prototype.hasOwnProperty.call(state.editor, variantUrlsafe) ? state.editor[variantUrlsafe] : {},
    gallery: state.gallery,
    token: ('token' in state.session) ? state.session.token : '',
  });
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Editor);



// WEBPACK FOOTER //
// ./scripts/containers/EditorContainer.jsx